import { getContext } from 'recompose';
import PropTypes from 'prop-types';

export const getLoadingSpinnerContext = getContext({
  showLoading: PropTypes.func,
  hideLoading: PropTypes.func,
});
